import {match} from 'ts-pattern';

import {SaleVehiclePhotoTypeGroup} from '@dms/api/settings';
import i18n from '@dms/i18n';

export const getSaleVehiclePhotoTypeGroupLabel = (group: SaleVehiclePhotoTypeGroup) =>
  match(group)
    .with('EXTERIOR', () => i18n.t('entity.saleVehiclePhotoTypeGroup.EXTERIOR'))
    .with('INTERIOR', () => i18n.t('entity.saleVehiclePhotoTypeGroup.INTERIOR'))
    .with('OTHER', () => i18n.t('entity.saleVehiclePhotoTypeGroup.OTHER'))
    .exhaustive();
